<div class="alert alert-danger alert-dismissable cust-alert" *ngIf="noDevicesFoundErrMsg">
    <div>
        <p class="mb-0">No Device Registered</p>
        <p>Click on Register New Device and Try again</p>
        <a class="close ml-auto pointer r-30">&times;</a>
    </div>
</div>


<header id="header" class="fixed-top">
    <div class="container d-flex align-items-center">

        <h1 class="logo mr-auto"><a href="index.html">min</a></h1>
        <nav class="nav-menu d-none d-lg-block">
            <ul>
                <li><a href="" [routerLink]="['/home']" routerLinkActive="router-link-active">Home</a></li>
                <li><a href="" [routerLink]="['/contactus']" routerLinkActive="router-link-active">Contact Us</a></li>
                <li><a href="" (click)="logout()" routerLinkActive="router-link-active">Logout</a></li>
            </ul>
        </nav>


    </div>
</header>

<div class="container mt-100" *ngIf="!isUnderMaintainance">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 mx-auto">
            <div class="row">
                <div class="col-sm-12 text-center">
                </div>
            </div>

            <div class="card shadow">
                <div class="card-body p-20 pb-0">
                    <div class="row">
                        <div class="col-lg-2">
                            <h4 *ngIf="!institutionInfo?.name" class="text-primary"><i>min</i></h4>
                            <h4 *ngIf="!institutionInfo?.logo">{{institutionInfo?.name}}</h4>
                            <img style="object-fit: contain;" src="{{institutionInfo?.logo}}" height="80" width="150"
                                alt="" *ngIf="institutionInfo?.logo">
                        </div>
                        <div class="col-lg-10 text-center">
                            <p class="fs-22 d-inline-flex"> <span class="material-icons text-danger fs-30">
                                    report
                                </span> &nbsp;Access to the application requires a Multi-Factor Authentication.</p>
                        </div>
                    </div>
                    <div *ngIf="isShowInstructionsToUpgrade && !isNewDeviceRegistered">
                        <h5 class="mb-2 mt-3">Important Instructions</h5>
                        <ul class="mb-0">
                            <li><strong>Min Security App</strong> has been renamed to <strong>Min
                                    Authenticator</strong>. It is now available on both the <strong>App Store</strong>
                                and <strong>Play Store</strong>.</li>

                            <li>To continue using Multi-Factor Authentication (MFA):</li>
                            <!-- <ul>
                                <li>Download the <strong>Min Authenticator</strong> app on your device.</li>
                                <li>Open the app and select <em>“Register New Device.”</em></li>
                                <li>Scan the barcode sent to you via email to complete the setup.</li>
                            </ul> -->
                        </ul>

                        <ul class="nav nav-tabs mb-3" id="authTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="ios-tab" data-toggle="tab" href="#ios" role="tab"
                                    aria-controls="ios" aria-selected="true">
                                    iOS
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="android-tab" data-toggle="tab" href="#android" role="tab"
                                    aria-controls="android" aria-selected="false">
                                    Android
                                </a>
                            </li>
                        </ul>


                        <div class="tab-content" id="authTabContent">
                            <div class="tab-pane fade show active" id="ios" role="tabpanel" aria-labelledby="ios-tab">
                                <div class="row align-items-start mb-4">
                                    <div class="col-md-2">
                                        <img src="../../assets/images/AppStoreQRCode.png" alt="iOS QR Code"
                                            class="img-fluid" />
                                    </div>
                                    <div class="col-md-10">
                                        <p><strong>For iOS users:</strong></p>
                                        <p>Open the <em>App Store</em>, search for <strong>“Min Authenticator”</strong>,
                                            and tap <em>Download</em> to install the app.</p>
                                        <p>Or scan the QR code to go directly to the app.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="android" role="tabpanel" aria-labelledby="android-tab">
                                <div class="row align-items-start mb-4">
                                    <div class="col-md-2">
                                        <img src="../../assets/images/PlayStoreQRCode.png" alt="Android QR Code"
                                            class="img-fluid" />
                                    </div>
                                    <div class="col-md-10">
                                        <p><strong>For Android users:</strong></p>
                                        <p>Open the <em>Google Play Store</em>, search for <strong>“Min
                                                Authenticator”</strong>, and tap <em>Install</em> to get the app.</p>
                                        <p>Or scan the QR code to go directly to the app.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>1. Click the button below to receive device enrollment instructions via email.</p>
                        <button class="btn btn-primary px-4 mb-3" (click)="enrollNew()">Send Device Enrollment
                            Instructions</button>
                        <p class="text-primary" *ngIf="emailSent">{{ emailSent }}</p>

                        <p>2. Once you receive the email, scan the QR code using the Min Authenticator app to complete
                            the registration.
                        </p>
                        <div class=" text-right mb-3">
                            <button class="btn btn-outline-primary" (click)="closeInstructions('skip')">Skip</button>
                            <button class="btn mx-2 btn-primary px-4" (click)="closeInstructions('ok')">Ok</button>
                        </div>
                    </div>
                    <div *ngIf="!isShowInstructionsToUpgrade && isNewDeviceRegistered">
                        <div class="row">
                            <div class="col-sm-5">
                                <h6 class="text-secondary pb-6 px-0 pt-15 d-flex">Registered Devices
                                    <span class="material-icons pointer text-primary ml-10 fs-18" title="edit"
                                        (click)="addDevice(adddevice)">
                                        edit
                                    </span>
                                    <span class="ml-30 d-flex pointer" (click)="getUserDevices()">
                                        <span class="material-icons pointer fs-18 text-secondary" title="edit">
                                            refresh
                                        </span> &nbsp; Get Devices
                                    </span>
                                </h6>
                                <span class="fs-18" *ngIf="userDevices.length == 0"> None </span> <button
                                    class="btn btn-primary" *ngIf="userDevices.length == 0"
                                    (click)="addDevice(adddevice)">Register New Device</button>
                                <div class="card  p-0 m-0" *ngIf="userDevices.length != 0">
                                    <div class="card-body p-0 m-0">
                                        <div class="form-group p-0 m-0">
                                            <select name="" id="" class="form-control" [(ngModel)]="selectedDeviceId"
                                                title="Select Device" (change)="chnageDeviceDetails()">
                                                <option value="{{item?.deviceId}}" *ngFor="let item of userDevices">
                                                    {{item?.deviceName}} <span
                                                        *ngIf="item?.phoneNumber != null && item?.phoneNumber != ''">
                                                        &nbsp;
                                                        &nbsp;
                                                        ({{item?.phoneNumber}})</span> </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 mb-4 px-0 pt-20">
                            <p class="fs-17">Please choose <b>one</b> of the below Authentication factors</p>
                            <!-- <div id="preloader-mfa" *ngIf="!locatedAdded"></div> -->
                            <div class="row" *ngIf="locatedAdded">
                                <div class="col-md-4 col-lg-3 d-fex pt-10"
                                    *ngIf="mfaGroupOptions?.pushFrEnabled && userDevices?.length != 0">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons mfa-icon">
                                                face
                                            </span>
                                            <h4 class="fs-17 font-weight-bold">Face Recognition</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('face', content)">Send Me
                                                    A Push</button>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10"
                                    *ngIf="mfaGroupOptions?.pushFpEnabled && userDevices?.length != 0">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons mfa-icon">
                                                fingerprint
                                            </span>
                                            <h4 class="fs-17 font-weight-bold">Finger Print</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('fingerPrint', content)">Send Me A Push</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10" *ngIf="mfaGroupOptions?.isEmailEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons mfa-icon">
                                                mail
                                            </span>
                                            <h4 class="fs-17 font-weight-bold">Email</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('email', content)">Email The Passcode</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10"
                                    *ngIf="mfaGroupOptions?.yubicoOtpEnabled || mfaGroupOptions?.yubicoFidoEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <!-- <span class="material-icons mfa-icon text-disabled">
                                                touch_app
                                            </span> -->
                                            <!-- *ngIf="mfaGroupOptions?.pushYnEnabled" -->
                                            <img src="../../assets/images/Yubico.svg" alt="minpin" height="50">
                                            <!-- <h4 class="fs-17 font-weight-bold text-disabled mb-0">Finger Vein</h4> -->
                                            <!-- <span class="fs-12">(Coming soon!)</span> -->
                                            <h4 class="fs-17 font-weight-bold mb-0">YubiKey</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('yubi', content)">Authenticate</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10" *ngIf="mfaGroupOptions?.phoneCallEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons mfa-icon">
                                                phone_in_talk
                                            </span>
                                            <h4 class="fs-17 font-weight-bold">Phone Call</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('phoneCall', content)">Call me</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10" *ngIf="mfaGroupOptions?.smsEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons mfa-icon">
                                                message
                                            </span>
                                            <h4 class="fs-17 font-weight-bold">Text-Message</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('otp', content)">Send SMS</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10" *ngIf="mfaGroupOptions?.otpEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <img src="../../assets/images/minpin.png" alt="minpin" height="50">
                                            <h4 class="fs-17 font-weight-bold">Min App Passcode</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('minPin', content)">Passcode on Min App</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-3 d-fex pt-10" *ngIf="mfaGroupOptions?.pushYnEnabled">
                                    <div class="card shadow h-100 mh-250">
                                        <div class="card-body pt-2 text-center">
                                            <span class="material-icons mfa-icon">
                                                settings_cell
                                            </span>
                                            <h4 class="fs-17 font-weight-bold">min Prompt</h4>
                                            <div class="align-items-center push-button px-15">
                                                <button class="btn btn-outline btn-block py-1 fs-14"
                                                    (click)="sendPush('minPrompt', content)">Send Me A
                                                    Push</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf=" !isShowInstructionsToUpgrade && !isNewDeviceRegistered">
                        <h5 class="text-secondary pb-6 px-0 pt-15">No Device Registered</h5>
                        <button class="btn btn-primary" (click)="addDevice(adddevice)">Register New Device</button>

                        <p class="fs-17">Please choose <b>one</b> of the below Authentication factors</p>
                        <div class="col-md-4 col-lg-3 d-fex pt-10" *ngIf="mfaGroupOptions?.isEmailEnabled">
                            <div class="card shadow h-100 mh-250">
                                <div class="card-body pt-2 text-center">
                                    <span class="material-icons mfa-icon">
                                        mail
                                    </span>
                                    <h4 class="fs-17 font-weight-bold">Email</h4>
                                    <div class="align-items-center push-button px-15">
                                        <button class="btn btn-outline btn-block py-1 fs-14"
                                            (click)="sendPush('email', content)">Email The Passcode</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>

                </div>
                <div class="card-footer text-center bg-white">
                    Powered by <i class="text-primary fs-18"> min </i>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Location Permission Modal -->
<div class="modal fade" id="locationPermissionModal" tabindex="-1" role="dialog" aria-labelledby="locationPermissionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content p-3">
        <div class="modal-header">
          <h5 class="modal-title" id="locationPermissionModalLabel">Enable Location Access</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>This app requires your location to work correctly. It looks like location access has been blocked.</p>
          <p><strong>To enable location access:</strong></p>
          <ul>
            <li>Click the controls icon next to the address bar</li>
            <li>Choose <strong>“Site settings”</strong> or locate the <strong>Location</strong> permission</li>
            <li>Set <strong>Location</strong> to <strong>"Allow"</strong></li>
            <li>Refresh the page</li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" (click)="closeModal()">Ok</button>
        </div>
      </div>
    </div>
  </div>
  

<div *ngIf="isUnderMaintainance">


    <div class="error-404">
        <div class="error-code m-b-10 m-t-20">503 <i class="fa fa-warning"></i></div>
        <h2 class="font-bold">503 Service Unavailable</h2>

        <div class="error-desc">
            Our website is currently undergoing scheduled maintenance.<br> We apologize for any inconvenience this may
            cause
            and
            appreciate your patience.<br>
            Please try again later.

            <div><br />
                <!-- <a class=" login-detail-panel-button btn" href="http://vultus.de/"> -->
                <button [routerLink]="['/login']" routerLinkActive="router-link-active" class="btn btn-primary"><span
                        class="glyphicon glyphicon-home"></span> Go back to
                    login </button> <br><br>
                <strong>Or</strong> <br><br>
                <button (click)="reload()" class="btn btn-outline-primary"><span
                        class="glyphicon glyphicon-home"></span>
                    Reload
                </button>


            </div>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="card-body" *ngIf="processing">
        <p class="text-center">
            <img src="../../../assets/images/spinner.gif" alt="" height="200px">
        </p>
    </div>
    <div *ngIf="!processing">
        <div class="card-body" *ngIf="ShowOtpScreen">
            <div class="col-lg-12 text-center">
                <h2 class="logo text-primary font-weight-bold"><i>min</i></h2>
            </div>
            <div class="col-lg-12"
                *ngIf="(pushType == 'otp' ||  pushType == 'email' ||   pushType == 'yubi') && !isPushNotificationsEnabled">
                <h4 class="small font-weight-bold py-10 fs-16">{{mfaResponce?.message}}</h4>
                <p *ngIf="pushType == 'yubi'">1.Insert your Yubikey into a USB port</p>
                <p *ngIf="pushType == 'yubi'">2.Mouse over to the Yubico OTP field below, and touch the Yubikey button
                </p>
                <div class="form-group" *ngIf="pushType == 'yubi'">
                    <label for="otp">Yubico OTP</label>
                    <input type="text" placeholder="Yubico OTP" name="otp" [(ngModel)]="otp" class="form-control"
                        id="otp" (keydown)="enterKey($event)">
                </div>
                <div class="form-group" *ngIf="pushType != 'yubi'">
                    <label for="otp">Verification Code</label>
                    <input type="text" placeholder="Enter verification code" name="otp" [(ngModel)]="otp"
                        class="form-control" id="otp" (keydown)="enterKey($event)">
                </div>
                <span> Verification code will expires in {{counter}} seconds </span>
            </div>
            <div class="col-lg-12" *ngIf="pushType == 'minPin'">
                <div class="form-group">
                    <label for="otp">Enter The Passcode</label>
                    <input type="text" placeholder="As shown on the dashboard of min app" name="otp" [(ngModel)]="otp"
                        class="form-control" id="otp" (keydown)="enterKey($event)">
                </div>
            </div>
        </div>
        <div class="card-body text-center"
            *ngIf="pushNotificationScreen && !isTimeExpired && !isPushNotificationsEnabled && !isFailedPushNotificationSent">
            <div class="col-lg-12">
                <h2 class="logo text-primary font-weight-bold"><i>min</i></h2>
            </div>
            <p class="font-weight-bold pb-20 fs-16 pb-0" *ngIf="pushType != 'phoneCall'">{{displayOptionType}} push
                notification sent
                to your <i>min</i> app. Please
                check your {{selectedDeviceName}} Mobile. </p>
            <p *ngIf="authenticatinFailed">Access Denied due to location Settings</p>
            <p class="font-weight-bold pb-20 fs-15 pb-0" *ngIf="pushType == 'phoneCall' && !authenticatinFailed">
                {{mfaResponce?.message}} <br>
                Answer the Phone, hear the message and press 1 to agree to get access to the application.
            </p>
            <p *ngIf="!authenticatinFailed" class="text-muted">Please Don't press back button or refresh.</p>
            <p *ngIf="pushType != 'phoneCall' && !authenticatinFailed"><span class="text-secondary pointer"
                    (click)="resendPush()">Click
                    here</span> to Resend Push Notification
            </p>
        </div>
        <div class="card-body text-left"
            *ngIf="pushNotificationScreen && (isTimeExpired || isPushNotificationsEnabled || isFailedPushNotificationSent)">
            <p class="fs-20" *ngIf="isTimeExpired">
                It’s been a minute, and we don’t see a response.<br> <br>
                Please ensure that Your device is: <br>
                - Not switched off and is reachable.<br>
                - Registered and has an active Min APP <br> <br>
                To get going: <br>
                You can as well cancel and choose other alternative MFA options to authenticate.
            </p>
            <p class="fs-20" *ngIf="isPushNotificationsEnabled">
                To use {{displayOptionType}} as an option, you will have to enable Push Notifications for the Min APP by
                following below instructions:<br><br>
                Navigate to Setting and Select Min App, select Allow Push Notifications, and Launch Min App on your
                device and try again.
            </p>
            <p class="fs-20" *ngIf="isFailedPushNotificationSent">
                Unable to send the {{displayOptionType}} notification <br>
                please ensure the Min app is installed and registered on {{selectedDeviceName}} and try again
            </p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
            <button class="btn btn-primary" (click)="validateOTP()" *ngIf="ShowOtpScreen">Submit</button>
        </div>
    </div>
</ng-template>


<ng-template #adddevice let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Edit Device Information</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card-body fs-17">
        <!-- <h5 class="text-secondary pb-10">New Device registration will require you to follow the below steps</h5>
        <p>1.Request to receive device enrollment email by clicking on below</p>
        <button class="btn btn-primary px-30 mb-10" (click)="enrollNew()">Send Device Enrollment Instructions</button>
        <p class="text-primary" *ngIf="emailSent">{{emailSent}}</p>
        <p>2.Once the email is received, then install the MinAPP on the new device and scan the QR Code to register the
            device.</p>
        <p>3.As a best practice, please remove the devices from below that you no longer use.</p> -->
        <div  *ngIf="isDeviceExists">
            <h5 class="mb-2 mt-3">Important Instructions</h5>
            <ul class="mb-0">
                <li><strong>Min Security App</strong> has been renamed to <strong>Min
                        Authenticator</strong>. It is now available on both the <strong>App Store</strong>
                    and <strong>Play Store</strong>.</li>
    
                <li>To continue using Multi-Factor Authentication (MFA):</li>
            </ul>
          </div>
              
        <h5 class="text-secondary pb-10" *ngIf="!isDeviceExists">New Device registration will require you to follow the
            below steps</h5>

        <ul class="nav nav-tabs mb-3" id="authTab" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="ios-tab" data-toggle="tab" href="#ios" role="tab" aria-controls="ios"
                    aria-selected="true">
                    iOS
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" id="android-tab" data-toggle="tab" href="#android" role="tab"
                    aria-controls="android" aria-selected="false">
                    Android
                </a>
            </li>
        </ul>


        <div class="tab-content" id="authTabContent">
            <div class="tab-pane fade show active" id="ios" role="tabpanel" aria-labelledby="ios-tab">
                <div class="row align-items-start mb-4">
                    <div class="col-md-2">
                        <img src="../../assets/images/AppStoreQRCode.png" alt="iOS QR Code" class="img-fluid" />
                    </div>
                    <div class="col-md-10">
                        <p><strong>For iOS users:</strong></p>
                        <p>Open the <em>App Store</em>, search for <strong>“Min Authenticator”</strong>, and tap
                            <em>Download</em> to install the app.
                        </p>
                        <p>Or scan the QR code to go directly to the app.</p>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade" id="android" role="tabpanel" aria-labelledby="android-tab">
                <div class="row align-items-start mb-4">
                    <div class="col-md-2">
                        <img src="../../assets/images/PlayStoreQRCode.png" alt="Android QR Code" class="img-fluid" />
                    </div>
                    <div class="col-md-10">
                        <p><strong>For Android users:</strong></p>
                        <p>Open the <em>Google Play Store</em>, search for <strong>“Min Authenticator”</strong>, and tap
                            <em>Install</em> to get the app.
                        </p>
                        <p>Or scan the QR code to go directly to the app.</p>
                    </div>
                </div>
            </div>
        </div>

        <p>1. Click the button below to receive device enrollment instructions via email.</p>
        <button class="btn btn-primary px-4 mb-3" (click)="enrollNew()">Send Device Enrollment Instructions</button>
        <p class="text-primary" *ngIf="emailSent">{{ emailSent }}</p>

        <p>2. Once you receive the email, scan the QR code using the Min Authenticator app to complete the registration.
        </p>
        <p>3. As a best practice, please remove any devices listed below that you no longer use.</p>


        <table class="table table-striped table-responsive w-100">
            <tbody *ngFor="let item of userDevices">
                <tr>
                    <th scope="row">{{item?.deviceName}}</th>
                    <td><button class="btn btn-outline" (click)="updateDeviceName(item)"
                            *ngIf="!item?.defaultDevice">Make It default</button>
                        <span class="badge badge-info" *ngIf="item?.defaultDevice">Current Default Device</span>
                    </td>
                    <td>
                        <div class="btn-group" role="group" aria-label="Basic example">
                            <button type="button" class="btn btn-info btn-sm"
                                (click)="editDeviceName(editdeviceName, item?.deviceId)">
                                <span class="material-icons">edit</span></button>
                            <button type="button" class="btn btn-danger btn-sm"
                                (click)="deleteUserDevice(item?.deviceId)"> <span
                                    class="material-icons">delete</span></button>
                        </div>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary px-30" (click)="getUserDevices()"
            (click)="modal.dismiss('Cross click')">Ok</button>
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
    </div>
</ng-template>


<ng-template #editdeviceName let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Edit Device Name</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card-body fs-17">
        <div class="form-group">
            <label for="devoiceName">Device Name</label>
            <input type="text" class="form-control" [(ngModel)]="deviceName" name="deviceName">
        </div>
        <div class="form-group form-check pl-0">
            <input type="checkbox" class="form-check-input" id="defaultDevice" [(ngModel)]="defaultDevice">
            <label class="form-check-label" for="defaultDevice">
                Make As Default Device
            </label>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary px-30" (click)="updateDeviceName(null)">Update</button>
        <button type="button" class="btn btn-outline" (click)="modal.dismiss('Cross click')">Cancel</button>
    </div>
</ng-template>